'use client'
const DEFAULT_BASE_API_URL = 'https://app.dynamicauth.com';
const DEFAULT_BASE_MPC_RELAY_API_URL = 'https://relay.dynamicauth.com';

export { DEFAULT_BASE_API_URL, DEFAULT_BASE_MPC_RELAY_API_URL };
